import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Lightweight cookie consent banner — KVKK + GDPR compliance.
 *
 * Runvya only uses essential cookies (JWT session + i18n language)
 * so this is a notice rather than a granular consent UI. Once
 * dismissed the choice persists in localStorage; never re-shown.
 *
 * Hidden on auth-only routes (Layout already runs there) and any
 * route the user actively dismisses on.
 */
const STORAGE_KEY = 'cookie_consent_v1';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      // Defer one tick so initial paint isn't blocked by the banner.
      const t = setTimeout(() => setShow(true), 200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    try { window.localStorage.setItem(STORAGE_KEY, 'accepted:' + Date.now()); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4 pointer-events-none">
      <div className="max-w-3xl mx-auto bg-gray-900/95 text-white rounded-lg shadow-2xl px-4 py-3 sm:px-5 sm:py-4
                      flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pointer-events-auto">
        <div className="text-sm flex-1 leading-relaxed">
          🍪 {t('shell.cookieConsent.text')}{' '}
          <Link to="/privacy" className="underline hover:text-blue-300">
            {t('shell.cookieConsent.privacy')}
          </Link>
        </div>
        <button onClick={accept}
                className="bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2 rounded whitespace-nowrap transition">
          {t('shell.cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
